import {
  BooleanStatusIndicator,
  BooleanStatusIndicatorProps,
} from "@/common/components/Status/BooleanStatusIndicator";
import { UtilizationStatus } from "@/core/api/generated/v1";

interface Props {
  status: UtilizationStatus | undefined;
  indicatorProps?: Partial<BooleanStatusIndicatorProps>;
}

export function UtilizationStatusIndicator({ status, indicatorProps }: Props) {
  return (
    <BooleanStatusIndicator
      value={status === UtilizationStatus.Utilized}
      size='small'
      {...indicatorProps}
    />
  );
}
